import { Phone, MessageCircle, Mail } from "lucide-react";

export const FloatingContactBar = ({ onContactClick }) => {
  return (
    <div className="fixed bottom-4 left-1/2 z-50 w-[92%] max-w-md -translate-x-1/2 rounded-2xl bg-black/90 backdrop-blur border border-white/10 shadow-xl">
      <div className="flex items-center justify-between px-4 py-3" sty>
        <a
          href="tel:+917207292771"
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-neutral-800 px-3 py-2 text-sm font-medium text-white hover:bg-neutral-700 transition"
        >
          <Phone size={16} />
          Call
        </a>
        {/* WhatsApp */}
        <a
          href="https://wa.me/+917207292771"
          target="_blank"
          rel="noopener noreferrer"
          className="mx-2 flex flex-1 items-center justify-center gap-2 rounded-xl bg-green-600 px-3 py-2 text-sm font-medium text-white hover:bg-green-700 transition"
        >
          <MessageCircle size={16} />
          WhatsApp
        </a>

        {/* Contact Us */}
        <button
          onClick={onContactClick}
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-white text-black px-3 py-2 text-sm font-medium hover:bg-neutral-200 transition"
        >
          <Mail size={16} />
          Contact
        </button>
      </div>
    </div>
  );
};
